var defaultStyles = {
  "root": "Base-Button",
  "xs": "Base-Button--Xs",
  "circle": "Base-Button--Circle",
  "rounded": "Base-Button--Rounded",
  "icon": "Base-Button--Icon",
  "sm": "Base-Button--Sm",
  "md": "Base-Button--Md",
  "lg": "Base-Button--Lg",
  "primary": "Base-Button--Primary",
  "solid": "Base-Button--Solid",
  "disabled": "Base-Button--Disabled",
  "outline": "Base-Button--Outline",
  "dashed": "Base-Button--Dashed",
  "text": "Base-Button--Text",
  "ghost": "Base-Button--Ghost",
  "secondary": "Base-Button--Secondary",
  "accent": "Base-Button--Accent",
  "warning": "Base-Button--Warning",
  "error": "Base-Button--Error",
  "info": "Base-Button--Info",
  "success": "Base-Button--Success",
  "loading_fixed_width": "Base-Button--LoadingFixedWidth",
  "loading": "Base-Button--Loading",
  "flat": "Base-Button--Flat",
  "raised": "Base-Button--Raised",
  "square": "Base-Button--Square",
  "link": "Base-Button--Link",
  "fluid": "Base-Button--Fluid",
  "labelHiddenOnLoad": "Base-Button--LabelHiddenOnLoad",
  "group": "Base-Button--Group",
  "anim-rotate": "Base-Button__anim--Rotate"
};

export { defaultStyles as default };
